module.exports = __webpack_public_path__ + "media/about/hero-964d15a0.jpg";